// extracted by mini-css-extract-plugin
export default {"categoryCard":"CategoryCard_categoryCard__RQmmg","categoryIcon":"CategoryCard_categoryIcon__ZoH6v","categoryTitle":"CategoryCard_categoryTitle__LpJMt"};